import styled from 'styled-components';

export default styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: var(--spacing-x-large);
	padding-bottom: var(--spacing-x-large);
	.full {
		grid-column-start: 2 span;
	}
	.half {
		grid-column-start: 1;
	}
	.label-name {
		display: flex;
		gap: var(--spacing-large);
		& > :first-child {
			flex-shrink: 0;
		}
	}
`;
